import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SearchBar from '../Components/SearchBar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import SuccessFailureModal from '../Components/Success_Failure_Modal_forDispatch';
import DropdownFlat from '../Components/DropdownFlat'
import authInstance from '../Classes/AuthHandler';
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'
  export default  class DocumentDashboard extends React.Component {

    constructor(props) {
        super(props);
        this.state={
         
          PONumber: this.props.location.state.PONumber,
          POItemNum:this.props.location.state.PoItem,
          WBSNum:this.props.location.state.WBSNo,
          modal: false,
          lorryreceiptmodal:false,
          SupplierDocuments:[
          {   value: 1, Name: "Packing Photo(Required)" ,Doc:"Document1.pdf"},
          {   value: 2, Name: "Painting Photo(Required)",Doc:"Document2.pdf" },
          {   value: 3, Name: "Packing List(Required)"  ,Doc:"Document3.pdf" },
          {   value: 4, Name: "Freight Template"        ,Doc:"Document4.pdf" }],

          SMSDocuments:[
            {   value: 1, Name: "Dispatch Clearence/Dispatch Inspection(Required)" ,Doc:"Document1.pdf"}],

            AssignTransporter: [{  value: 1,  transporter: "ABC supplier"},
                    {  value: 2,  transporter: "CDE supplier"},
                    {  value: 3,  transporter: "EFG supplier"},
                ],
            assigntransportermodal:false,
            comments:''
          
            
      }
      
      this.assigntransportermodal= this.assigntransportermodal.bind(this);
      this.comments = this.comments.bind(this);
      this.lorryreceiptmodal=this.lorryreceiptmodal.bind(this);
      this.modal= this.modal.bind(this);
    
    }
    
    assigntransportermodal() {
      this.setState({ assigntransportermodal: !this.state.assigntransportermodal });
        
          if(this.state.assigntransportermodal ==true){
              this.setState(
              {opacity:""}
              )
             }
          else{
              this.setState(
                 {opacity:"0.2"} 
              )}}


     handleSelect=(e)=>{
      this.setState({
      selectedpaymentmethod : e.target.value
      })
       
  }         

     comments(event) { 
       this.setState({comments: event.target.value})
      //  console.log(this.state.comments,"comments") ;
      }

      modal() {
        this.setState({ modal: !this.state.modal });
          if(this.state.lorryreceiptmodal==true){
            this.setState({ lorryreceiptmodal: !this.state.lorryreceiptmodal });
          }
            if(this.state.modal ==true){
                this.setState(
                {opacity:""}
                )
               }
            else{
                this.setState(
                   {opacity:"0.2"} 
                )}}
  
                
        modalLogistics() {
        this.setState({ modalLogistics: !this.state.modalLogistics });
          if(this.state.lorryreceiptmodal==true){
            this.setState({ lorryreceiptmodal: !this.state.lorryreceiptmodal });
          }
            if(this.state.modalLogistics ==true){
                this.setState(
                {opacity:""}
                )
               }
            else{
                this.setState(
                   {opacity:"0.2"} 
                )}}
  
      lorryreceiptmodal() {
        this.setState({ lorryreceiptmodal: !this.state.lorryreceiptmodal });
                  
            if(this.state.lorryreceiptmodal ==true){
                this.setState(
                 {opacity:""}
                )
               }
            else{
                this.setState(
                    {opacity:"0.2"} 
          )}}

          toggleSuccessModal(e){
            this.setState({ modal: !this.state.modal });
            if(this.state.modal ==true){
              this.setState(
            {opacity:""}
              )}
          else{
              this.setState(
                 {opacity:"0.2"} 
              ) }
            }

    render()
    {
      var roles = authInstance.getRoles()
      var groups = authInstance.getGroups()
        return(
            <div className="Container-fluid pageheight"  >
               

               <div className="Container-fluid p-4" >
                 {/* ---------Assign Transporter Modal Start-------- */}

               <Modal isOpen={this.state.assigntransportermodal} >
            <div className={"modal-bg" + (this.state.assigntransportermodal === 'false'  ? 'open' : '')}>
                <div className="modalheads">
                <ModalHeader HeaderStyle="modal-header modalheaderWide2">
                    <div><h4 >Assign Transporter</h4></div>
                    <button type="button" className="close" aria-label="Close" onClick={this.assigntransportermodal} >
                         <span aria-hidden="true">&times;</span>
                    </button>
                </ModalHeader>
                </div>
                    <div >
                <ModalBody Style="modal-body modalbodysWide2">
                   

                 <div className="row ml-2 pt-2 ">
                        <div className="col-md-6 pt-2 " >
                            <div className="row">
                                <div className="col" ><b>PO No. :</b></div> 
                                <div className="col">ABC</div>    
                            </div>
                        
                        </div>
                        <div className="col-md-6 pt-2">
                            <div className="row">
                                    <div className="col" ><b>Payment Term :</b></div> 
                                    <div className="col ">ABC</div>    
                                </div>
                            </div>
                 </div>

                 <div className="row ml-2 pt-2 ">
                        <div className="col-md-6 pt-2 " >
                            <div className="row">
                                <div className="col" ><b>PO Date :</b></div> 
                                <div className="col">ABC</div>    
                            </div>
                        
                        </div>
                        <div className="col-md-6 pt-2">
                            <div className="row">
                                    <div className="col" ><b>PO Quantity :</b></div> 
                                    <div className="col ">ABC</div>    
                                </div>
                            </div>
                 </div>

                 <div className="row ml-2 pt-2 ">
                        <div className="col-md-6 pt-2 " >
                            <div className="row">
                                <div className="col" ><b>WBS No. :</b></div> 
                                <div className="col">ABC</div>    
                            </div>
                        
                        </div>
                        <div className="col-md-6 pt-2">
                            <div className="row">
                                    <div className="col" ><b>Location :</b></div> 
                                    <div className="col ">ABC</div>    
                                </div>
                            </div>
                 </div>


                   <div className="row ml-2 pt-2">
                       <div className="col-md-3"><b>Assign Transporter :</b></div> 
                       <div className="col-md-7">
                       <DropdownFlat defaultopt="Select Option"  data={this.state.AssignTransporter} actions={this.handleSelect} keyObjName={"value"} valueObjName={"transporter"} />
                         </div>
                   </div>

                 <div className="row ml-2 pt-2">
                       <div className="col-md-3"><b>Comments <em>(if any)</em> :</b></div> 
                       <div className="col-md-7">
                         <textarea className="form-control" rows="2" value={this.state.comments} onChange={this.comments}></textarea>
                         </div>
                   </div>

                 
                           
                            
                        
                   
                   
                </ModalBody>
                </div>
                <div>    
                <ModalFooter FooterStyle="modal-footer modalfooterWide2">
                <div>
                <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.assigntransportermodal} type="submit">Confirm</button>
                
                  <button className="btn2 btn-sms3 mt-2 ml-4 float-right" onClick={this.assigntransportermodal} type="submit">Cancel</button>
                
                
                
                </div>

                    
                </ModalFooter>
                </div>
                </div>
                </Modal>

                {/* ---------Assign Transporter Modal End-------- */}

                {/* ---------Upload Lorry Receipt Modal Start-------- */}

               <Modal isOpen={this.state.lorryreceiptmodal} >
            <div className={"modal-bg" + (this.state.lorryreceiptmodal === 'false'  ? 'open' : '')}>
                <div className="modalheads">
                <ModalHeader HeaderStyle="modal-header modalheaderWide2">
                    <div><h4 >Upload Lorry Receipt</h4></div>
                    <button type="button" className="close" aria-label="Close" onClick={this.lorryreceiptmodal} >
                         <span aria-hidden="true">&times;</span>
                    </button>
                </ModalHeader>
                </div>
                    <div >
                <ModalBody Style="modal-body modalbodysWide2">
                   

                 <div className="row ml-2 pt-2 ">
                        <div className="col-md-6 pt-2 " >
                            <div className="row">
                                <div className="col" ><b>PO No. :</b></div> 
                                <div className="col">ABC</div>    
                            </div>
                        
                        </div>
                        
                 </div>


                 <div className="row ml-2 pt-2 ">
                        <div className="col-md-6 pt-2 " >
                            <div className="row">
                                <div className="col" ><b>PO Item :</b></div> 
                                <div className="col">ABC</div>    
                            </div>
                        
                        </div>
                        <div className="col-md-6 pt-2 " >
                            <div className="row">
                                <div className="col" ><b>WBS No. :</b></div> 
                                <div className="col">ABC</div>    
                            </div>
                        
                        </div>
                        
                 </div>


                   <div className="row ml-2 pt-2">
                       <div className="col-md-3"><b>Lorry Receipt :</b></div> 
                       <div className="col-md-7">
                          <FontAwesomeIcon className="align-middle pr-2" icon={"upload"}  color={"black"} title="Upload" size="2x"/>
                         </div>
                   </div>

                 <div className="row ml-2 pt-2">
                       <div className="col-md-3"><b>Comments <em>(if any)</em> :</b></div> 
                       <div className="col-md-7">
                         <textarea className="form-control" rows="2" value={this.state.comments} onChange={this.comments}></textarea>
                         </div>
                   </div>

                 
                           
                            
                        
                   
                   
                </ModalBody>
                </div>
                <div>    
                <ModalFooter FooterStyle="modal-footer modalfooterWide2">
                <div>
                <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.modal} type="submit">Confirm</button>
                
                  <button className="btn2 btn-sms3 mt-2 ml-4 float-right" onClick={this.lorryreceiptmodal} type="submit">Cancel</button>
                
                
                
                </div>

                    
                </ModalFooter>
                </div>
                </div>
                </Modal>

                {/* ---------Upload Lorry Receipt Modal End-------- */}
                <div>
                <SuccessFailureModal action={this.state.modal} toggleSuccessModal={(e)=>this.toggleSuccessModal(e)}
                  headertitle="Successful" text="PO Item: 10,11 has been dispatched successfully. " icon='check-circle' iconcolor="green"   FooterButton="OK" path='/TestModal' />
                </div>
                <div className="row">
                  <div className="col pt-2 ">
                      <div className="col pt-2  ">
                      <b>PO No: {this.state.PONumber}</b> 
                      </div>
                      <div className="col pt-2  ">
                      <b>PO Item: {this.state.POItemNum }</b> 
                      </div>
                      <div className="col pt-2 ">
                      <b>WBS No: {this.state.WBSNum}</b>  
                      </div>
                      <div className="col pt-2 ">
                      <b>Status: </b>  
                      </div>
                      
                    
                  </div>
                  <div className="col pt-2 ">
                          {roles[13] ?<> 
                            <Link  to ={{ pathname: '',state : { PONumber:this.state.PONumber} }}>     
                            <button className=" btn2 btn-sms1 rounded float-right mr-2" type="submit"
                            onClick={this.lorryreceiptmodal} 
                            > Arrange Transport </button> 
                            </Link>
                        </>:<> </> }  
                    </div>
                    </div>
                <br />
                <br />
                <div className="row pl-2 pr-4">
                   <div className="col-md-12 ml-2  red1 border">Documents Dashboard</div> 
                </div>
                <div>
                    <div className="row pl-2 pt-2 pr-4">
                      <div className="col-md-12 ml-2 dispatch-bg border">SMS Documents</div> 
                    </div>

                    <div className="row pl-2 pr-4">
                      <div className="col ml-2 pr-2 ">
                      {this.state.SMSDocuments.map((items,Index)=>
                          <div className="row border  ">
                              
                              <div className="col-md-6 border">{items.Name}</div>
                              <div className="col-md-6 border textcolor">
                               
                                <div className="row">
                                  <div className="col">{items.Doc}</div>
                                  <div className="col">
                                  <button className="btn2 btn-sms3 rounded  float-right   ">View</button>
                                  </div>
                                </div>
                                
                                </div>
                              
                          </div>
                      )}
                      </div>
                    </div>
                </div>
                <div>
                    <div className="row pl-2 pr-4">
                      <div className="col-md-12 ml-2 dispatch-bg border">Supplier Documents</div> 
                    </div>

                    <div className="row pl-2 pr-4 ">
                      <div className="col ml-2 pr-2 ">
                         {this.state.SupplierDocuments.map((item,index)=>
                         
                          <div className="row border  ">
                              
                              <div className="col-md-6 border">
                                {item.Name}
                                
                              </div>
                              <div className="col-md-6 border textcolor">
                                <div className="row">
                                  <div className="col">{item.Doc}
                                </div>
                                  <div className="col">

                                    
                                  
                                  
                                  
                              {/* for purchase team assign button */}
                                    {roles[15] ? <>
                                        {item.Name=="Freight Template"?
                                          <><FontAwesomeIcon className="align-middle pr-2" icon={"download"}  color={"black"} title="download" size="2x"/>
                                             <button className="btn2 btn-sms2 float-right" onClick={this.assigntransportermodal}>Assign</button>
                                            
                                          </>
                                          : 
                                          <><button className="btn2 btn-sms3 rounded  float-right ">View</button></>
                                          
                                        }
                                        </>:
                                      
                                        <><button className="btn2 btn-sms3 rounded  float-right ">View</button>
                                        
                                       </>
                                       
                                      
                                       
                                        
                                        
                                    } 



                                    
                                      
                                  </div>
                                </div>
                                
                                </div>
                              
                          </div>
                          )}
                      </div>
                    </div>
                    <div><button className="btn2 btn-sms1 mt-4   float-right  ">Save</button></div>
                </div>
                
                
  
            </div>
            </div>
            
        )
    }
}